import React, { Component } from "react";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import Alert from "../../UI/Alert/Alert";
import Select from "react-select";
import { Link } from "react-router-dom";
import styles from "./CreateContactList.module.css";
import { HOST_URL, NODE_HOST_URL } from "../api/Api";
import { handleUserLog } from "../../Utils/Utils";

class CreateContactList extends Component {
  constructor() {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage.user.userId;
    const token = lStorage.token;
    const user_type = lStorage.user.user_type;

    super();

    this.state = {
      userId: user_id,
      token: token,
      userType: user_type,
      contactListName: "",
      description: "",
      list_type: "",
      agentList: [],
      teamList: [],
      selectedAgent: [],
      selectedTeam: "",
      assignType: "",
      teamAgents: [],
      isError: false,
      errorMessage: "",
      messageType: "",
      isLoadingAgents: false,
      hasAgents: false,
    };

    this.createContact = this.createContact.bind(this);
    this.fetchAgents = this.fetchAgents.bind(this);
  }

  componentDidMount() {
    this.fetchAgents();
  }

  fetchAgents() {
    this.setState({ isLoadingAgents: true });

    const lStorage = JSON.parse(localStorage.getItem("login"));

    const payload = {
      user_id: lStorage.user.parent_id || this.state.userId,
      method: "retrieve_agent",
      token: lStorage.user.parent_token || this.state.token,
      user_type: "client",
      agent_id: this.state.userId,
    };

    fetch(`${NODE_HOST_URL}/whatsapp_agent`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success === true && Array.isArray(data.data)) {
          const agents = data.data.filter(
            (agent) => agent.agent_type === "agent"
          );
          const teams = data.data.filter(
            (agent) => agent.agent_type === "team"
          );
          // console.log(data.data);

          this.setState({
            agentList: agents,
            teamList: teams,
            hasAgents: agents.length > 0 || teams.length > 0,
            isLoadingAgents: false,
            isError: false,
            errorMessage: "",
          });
        } else if (data.message === "data not found") {
          this.setState({
            agentList: [],
            teamList: [],
            hasAgents: false,
            isLoadingAgents: false,
            isError: false,
            errorMessage: "",
          });
        } else {
          this.setState({
            isError: true,
            messageType: "alert-danger",
            errorMessage: data.message || "Failed to fetch agents.",
            isLoadingAgents: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          isError: true,
          messageType: "alert-danger",
          errorMessage: "Error fetching agents.",
          isLoadingAgents: false,
        });
      });
  }

  // ✅ Filter agents belonging to selected team
  handleTeamSelect = (teamId) => {
    const { teamList, agentList } = this.state;
    const selectedTeam = teamList.find((team) => team.id === parseInt(teamId));
    const teamAgents = agentList.filter(
      (agent) => agent.team_name === selectedTeam?.name
    );

    this.setState({
      selectedTeam: teamId,
      teamAgents: teamAgents,
      selectedAgent: [],
    });
  };

  createContact() {
    const createListData = {
      user_id: this.state.userId,
      token: this.state.token,
      method: "create",
      name: this.state.contactListName,
      list_type: this.state.list_type,
      description: this.state.description,
      selected_agent: this.state.selectedAgent,
    };

    fetch(`${HOST_URL}/contact-list.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(createListData),
    })
      .then((result) => result.json())
      .then((resp) => {

        if (resp.success === true) {

          handleUserLog(
            "",
            "clicked_create_contact_list_button",
            "contact_list",
            resp.message || "Contact list created successfully",
            "contact_list",
            "",
            {
              contact_list_name: this.state.contactListName,
              list_type: this.state.list_type,
              description: this.state.description,
              selected_agent: this.state.selectedAgent
            }
          );

          document.querySelector("body").scrollTo(0, 0);

          this.setState({
            isError: true,
            messageType: "alert-success",
            errorMessage: resp.message || "Contact list created successfully",
          });

          setTimeout(() => {
            this.props.history.push("contact-list");
          }, 1000);

        } else {

          handleUserLog(
            "",
            "clicked_create_contact_list_button_failed",
            "contact_list",
            resp.message || "Failed to create contact list",
            "contact_list",
            "",
            {
              contact_list_name: this.state.contactListName,
              list_type: this.state.list_type
            }
          );

          this.setState({
            isError: true,
            messageType: "alert-danger",
            errorMessage: resp.message || "Failed to create contact list.",
          });
        }
      })
      .catch((error) => {

        handleUserLog(
          "",
          "clicked_create_contact_list_button_error",
          "contact_list",
          error?.message || "An error occurred while creating the list",
          "contact_list",
          "",
          {
            contact_list_name: this.state.contactListName,
            list_type: this.state.list_type
          }
        );

        this.setState({
          isError: true,
          messageType: "alert-danger",
          errorMessage: "An error occurred while creating the list.",
        });
      });
  }

  render() {
    const {
      isError,
      messageType,
      errorMessage,
      isLoadingAgents,
      hasAgents,
      agentList,
      teamList,
      assignType,
      teamAgents,
    } = this.state;

    return (
      <DashboardLayout>
        <main className="content">
          <div className="container-fluid p-0">

            {/* Page Header */}
            <div className={styles.pageHeader}>
              <div>
                <h4 className={styles.pageTitle}>Create Contact List</h4>
                <p className={styles.pageSubtitle}>Set up a new contact list and assign it to agents or teams</p>
              </div>
            </div>

            <div className={styles.pageGrid}>

              {/* ── Left: Form card ── */}
              <div className={styles.formCard}>

                <div className={styles.cardHeader}>
                  <div className={styles.cardTitle}>New Contact List</div>
                  <Link to="/dashboard/contact-list" className={styles.backBtn}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2.5"
                      strokeLinecap="round" strokeLinejoin="round"
                      aria-hidden="true">
                      <path d="M19 12H5M12 5l-7 7 7 7" />
                    </svg>
                    Back to List
                  </Link>
                </div>

                <div className={styles.cardBody}>

                  {isError && <Alert type={messageType}>{errorMessage}</Alert>}

                  {/* Contact list name */}
                  <div className={styles.fieldGroup}>
                    <label className={styles.label}>Contact List Name</label>
                    <input
                      type="text"
                      className={styles.input}
                      onChange={(e) => this.setState({ contactListName: e.target.value })}
                      placeholder="e.g. WhatsApp Campaign June"
                    />
                  </div>

                  {/* List type */}
                  <div className={styles.fieldGroup}>
                    <label className={styles.label} required >
                      List Type
                    </label>
                    <select
                      className={styles.select}
                      onChange={(e) => this.setState({ list_type: e.target.value })}
                      required
                    >
                      <option value="">Select List Type</option>
                      <option value="contact">Contact</option>
                      <option value="wp_chat">WhatsApp Chat</option>
                      <option value="rcs_chat">RCS Chat</option>
                      <option value="integration">Integration</option>
                    </select>
                  </div>

                  {/* Assign To */}
                  <div className={styles.assignGrid}>
                    <div className={styles.fieldGroup}>
                      <label className={styles.label}>Assign To</label>
                      {isLoadingAgents ? (
                        <select
                          className={styles.select}
                          disabled
                          style={{ opacity: 0.6, cursor: "not-allowed" }}
                        >
                          <option>Loading agents...</option>
                        </select>
                      ) : !hasAgents ? (
                        <>
                          <select
                            className={styles.select}
                            disabled
                            style={{ opacity: 0.6, cursor: "not-allowed" }}
                          >
                            <option>No agents available</option>
                          </select>
                          <p style={{ marginTop: "6px", fontSize: "12px", color: "#888" }}>
                            No agents have been added yet.
                          </p>
                        </>
                      ) : (
                        <select
                          className={styles.select}
                          onChange={(e) =>
                            this.setState({
                              assignType: e.target.value,
                              selectedAgent: [],
                              selectedTeam: "",
                              teamAgents: [],
                            })
                          }
                        >
                          <option value="">Select Type</option>
                          {agentList.length > 0 && <option value="agent">Agent</option>}
                          {teamList.length > 0 && <option value="team">Team</option>}
                        </select>
                      )}
                    </div>

                    {hasAgents && assignType === "team" && (
                      <div className={styles.fieldGroup}>
                        <label className={styles.label}>Team Name</label>
                        <select
                          className={styles.select}
                          onChange={(e) => this.handleTeamSelect(e.target.value)}
                        >
                          <option value="">Select Team</option>
                          {teamList.map((team) => (
                            <option key={team.id} value={team.id}>{team.name}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    {hasAgents && assignType === "agent" && (
                      <div className={styles.fieldGroup}>
                        <label className={styles.label}>Select Agents</label>
                        <Select
                          isMulti
                          isLoading={isLoadingAgents}
                          options={agentList.map((a) => ({ value: a.id, label: a.name }))}
                          placeholder="Select one or more agents..."
                          classNamePrefix="select"
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderRadius: "8px",
                              borderColor: "#e0ddf0",
                              boxShadow: "none",
                              fontSize: "13px",
                            }),
                            multiValue: (base) => ({ ...base, backgroundColor: "#ede9f8" }),
                            multiValueLabel: (base) => ({ ...base, color: "#3f3966" }),
                          }}
                          onChange={(selected) =>
                            this.setState({
                              selectedAgent: selected ? selected.map((s) => s.value) : [],
                            })
                          }
                        />
                      </div>
                    )}

                    {hasAgents && assignType === "team" && this.state.selectedTeam && teamAgents.length > 0 && (
                      <div className={styles.fieldGroup}>
                        <label className={styles.label}>Select Team Agents</label>
                        <Select
                          isMulti
                          options={teamAgents.map((a) => ({ value: a.id, label: a.name }))}
                          placeholder="Select one or more team agents..."
                          classNamePrefix="select"
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderRadius: "8px",
                              borderColor: "#e0ddf0",
                              boxShadow: "none",
                              fontSize: "13px",
                            }),
                            multiValue: (base) => ({ ...base, backgroundColor: "#ede9f8" }),
                            multiValueLabel: (base) => ({ ...base, color: "#3f3966" }),
                          }}
                          onChange={(selected) =>
                            this.setState({
                              selectedAgent: selected ? selected.map((s) => s.value) : [],
                            })
                          }
                        />
                      </div>
                    )}
                  </div>

                  {/* Description */}
                  <div className={styles.fieldGroup}>
                    <label className={styles.label} required >Description</label>
                    <textarea
                      rows={3}
                      className={styles.textarea}
                      onChange={(e) => this.setState({ description: e.target.value })}
                      placeholder="Brief description of this contact list..."
                    />
                  </div>

                </div>

                <div className={styles.formFooter}>
                  <button onClick={this.createContact} className={styles.createBtn}>
                    Create List
                  </button>
                </div>

              </div>

              {/* ── Right: Notes card ── */}
              <div className={styles.notesCard}>
                <div className={styles.notesHeader}>
                  <p className={styles.notesTitle}>Important Notes</p>
                </div>
                <div className={styles.notesBody}>
                  <ol className={styles.notesList}>
                    <li>When uploading a CSV, pass <strong>sender_id</strong> as <strong>null</strong> for all approved sender IDs if you want to apply the template ID to them.</li>
                    <li>During CSV upload, always use the approved sender_id; otherwise, do not use it when sending SMS.</li>
                    <li>Do not remove the first row of the sample file during CSV upload.</li>
                  </ol>
                </div>
              </div>

            </div>
          </div>
        </main>
      </DashboardLayout>
    );
  }
}

export default CreateContactList;
